<template lang="pug">
nav#v-navigation: .container
  img.logo(src='@/assets/to-logo.png', alt='TechOrange 科技報橘')
  transition(name='dimmer'): .dimmer(v-if='mobileMenuExpanded', @click='mobileMenuExpanded = false')
  ul(:class='{expanded: mobileMenuExpanded}')
    li(:class='{active: $store.state.scroll.position === "topics"}')
      a(v-scroll-to='{el: "#v-topics", offset: -$store.state.scroll.offset}', @click='mobileMenuExpanded = false', href='#topics') TOPICS
    li(:class='{active: $store.state.scroll.position === "speakers"}')
      a(v-scroll-to='{el: "#v-speakers", offset: -$store.state.scroll.offset}', @click='mobileMenuExpanded = false', href='#speakers') 講者＆主持人
    li(:class='{active: $store.state.scroll.position === "agenda"}')
      a(v-scroll-to='{el: "#v-agenda", offset: -$store.state.scroll.offset}', @click='mobileMenuExpanded = false', href='#agenda') 議程
    li(:class='{active: $store.state.scroll.position === "ticketing"}')
      a(v-scroll-to='{el: "#v-ticketing", offset: -$store.state.scroll.offset}', @click='mobileMenuExpanded = false', href='ticketing') 活動資訊
    li(:class='{active: $store.state.scroll.position === "highlight"}')
      a(v-scroll-to='{el: "#v-highlight", offset: -$store.state.scroll.offset}', @click='mobileMenuExpanded = false', href='highlight') 歷年回顧
  img.menu(v-if='$store.state.mobile', @click='mobileMenuExpanded = !mobileMenuExpanded', src='@/assets/menu-icon.png', width='30')
</template>

<script>
export default {
  name: 'Navigation',
  data() {
    return {
      mobileMenuExpanded: false
    }
  },
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-navigation
  +border(1px, #DFFF00)
  +position(fixed, 0, 0, null, 0)
  +flex(null, center)
  background-color: black
  height: 70px
  z-index: 99
  .container
    +flex(space-between, center)
.logo
  width: 167px
ul
  +flex(space-between)
  list-style-type: none
  width: 580px
  li
    +font(18px, white, null, 1.12px, 500)
    cursor: pointer
    transition: color .2s
    &:hover, &.active
      color: #DFFF00
    &.disabled
      color: darkgrey
      pointer-events: none
    a:hover
      text-decoration: none

@media (max-width: 1023px)
  .dimmer-enter-active, .dimmer-leave-active
    transition: opacity .3s
  .dimmer-enter, .dimmer-leave-to
    opacity: 0 !important

  #v-navigation
    height: 50px
  .logo
    width: 136px
  .menu
    cursor: pointer
  .dimmer
    +position(fixed, 50px, 0, 0, 0)
    background-color: black
    opacity: .6
  ul
    +border(0 1px 1px 1px, #DFFF00)
    +flex(flex-start, center, column)
    +position(fixed, 50px, 0, 0)
    background-color: black
    transform: translateX(100%)
    transition: transform .3s
    padding-top: 60px
    width: 200px
    &.expanded
      transform: translateX(0)
    li
      margin-bottom: 40px
      font-size: 17px
      &:first-child
        font-family: 'Montserrat Alternates'
</style>
